import React from 'react'
import { useContext, useEffect } from 'react'
import { AppContext } from '../../../services/Appcontext'
import Pagetemplate from '../../templates/Pagetemplate'
import { useTranslation } from 'react-i18next'

const buttonLabels = ['سمير غانم', 'label 2', 'label 3', 'label 4', 'label 5', 'label 6', 'label 7', 'label 8', 'label 9'];
const title1="حرف  الألف"
const title2="حرف  الباء"
const title3 = "حرف  التاء"
const title=[title1,title2,title3]
export default function Characterspage() {
  const {getMostSearched, mostSearched,
          charByLetter,getCharByLetter,
          searchValue
  } = useContext(AppContext)
  const { i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";

useEffect(() => {
  getMostSearched(8)
  getCharByLetter(searchValue, isArabic)
},[searchValue, isArabic])

// console.log("data of the الشخصيات",mostSearched.data, charByLetter.data)
// console.log("data of the الشخصيات", charByLetter.data)

  return (
    <div>
        <Pagetemplate  
            introdata={mostSearched.data} 
            contentData={charByLetter.data}
            defaultChecked="chars"
            title={title}
            ></Pagetemplate>
    </div>
  )
}
